export default "__VITE_ASSET__41304632__"